import { useDemoCtx } from './DemoContext';

const SENSORS = [
    { name: '토양수분센서 #1', id: 'SNS-M-001', ico: '💧', icoClass: 's-ico-blue',  val: '41', unit: '토양 수분율',  pct: 41, c: 'var(--warn)',    site: '송파 올림픽B',    online: true },
    { name: '토양수분센서 #2', id: 'SNS-M-002', ico: '💧', icoClass: 's-ico-green', val: '72', unit: '토양 수분율',  pct: 72, c: 'var(--good)',    site: '강남 중앙공원 A', online: true },
    { name: '기상관측센서 #1', id: 'SNS-W-001', ico: '🌡️', icoClass: 's-ico-blue', val: '23', unit: '외기 온도',    pct: 46, c: 'var(--caution)', site: '강남구 전역',     online: true },
    { name: '토양EC센서 #1',   id: 'SNS-EC-001', ico: '⚡', icoClass: 's-ico-green', val: '1.2', unit: '전기전도도', pct: 24, c: 'var(--text2)',   site: '송파 올림픽B',    online: true },
    { name: '토양수분센서 #5', id: 'SNS-M-005', ico: '⚠️', icoClass: 's-ico-red',  val: '--', unit: '연결 오류',   pct:  0, c: 'var(--danger)',  site: '용산 미군기지',   online: false },
    { name: '강수량센서 #1',   id: 'SNS-R-001', ico: '🌧️', icoClass: 's-ico-blue', val: '12.4', unit: '주간 누적 강수', pct: 24, c: 'var(--caution)', site: '전체 구역',   online: true },
];

const UNIT_SUFFIX: Record<string, string> = {
    '토양 수분율': '%', '외기 온도': '°C', '전기전도도': ' dS', '주간 누적 강수': 'mm',
};

export default function DemoSensors() {
    const { toast } = useDemoCtx();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
            <div className="list-bar">
                <div style={{ fontSize: 13.5, fontWeight: 800 }}>센서 관리</div>
                <div style={{ flex: 1 }} />
                <span className="text-xs text-muted" style={{ fontWeight: 600 }}>총 18개 · <span style={{ color: 'var(--good)' }}>15개 온라인</span> · <span style={{ color: 'var(--danger)' }}>3개 오프라인</span></span>
                <button className="btn btn-primary btn-sm" onClick={() => toast('센서 등록 폼', 'success')}>＋ 센서 추가</button>
            </div>

            <div className="sensor-grid" style={{ flex: 1, overflowY: 'auto' }}>
                {SENSORS.map((s, i) => (
                    <div key={i} className={`sensor-card fade-up d${i}`} style={!s.online ? { borderColor: '#FECACA' } : {}}>
                        <div className="sensor-card-top">
                            <div>
                                <div className="sensor-name">{s.name}</div>
                                <div className="sensor-id">{s.id}</div>
                            </div>
                            <div className={`sensor-ico ${s.icoClass}`}>{s.ico}</div>
                        </div>
                        <div className="sensor-reading" style={{ color: s.c }}>
                            {s.val}
                            {s.online && <span style={{ fontSize: 14 }}>{UNIT_SUFFIX[s.unit] ?? ''}</span>}
                        </div>
                        <div className="sensor-unit" style={!s.online ? { color: 'var(--danger)' } : {}}>{s.unit}</div>
                        <div className="sensor-bar">
                            <div className="sensor-bar-fill" style={{ width: `${s.pct}%`, background: s.c }} />
                        </div>
                        <div className="sensor-meta">
                            <div className="sensor-meta-item">{s.site}</div>
                            {s.online ? <div className="s-online">온라인</div> : <div className="s-offline">● 오프라인</div>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
